/**
 * Class representing LoginService
 * @memberOf services.login
 * @ngdoc service
 * @name LoginService
 */
class LoginService {
  constructor($http, $window, $q, $state, AuthService, Idle) {
    /**
     * @type {service}
     * @memberOf LoginService
     * @description Instance of Angular $http service
     */
    this.$http = $http;

    /**
     * @type {service}
     * @memberOf LoginService
     * @description Instance of Angular $window service, referencing browser's window object
     */
    this.$window = $window;

    /**
     * @type {service}
     * @memberOf LoginService
     * @description Instance of Angular $q service
     */
    this.$q = $q;

    /**
     * @type {service}
     * @memberOf LoginService
     * @description Instance of AuthService
     */
    this.authService = AuthService;

    /**
     * @type {service}
     * @memberOf LoginService
     * @description Instance of ngIdle's service for watching idleness of screen.
     */
    this.idle = Idle;
  }

  /**
   * @memberOf LoginService
   * @param {string} email Email address of user from form
   * @description Call /api/auth/sendtoken to request a token for user
   * @returns {string} If token request is a success, then returns success result, otherwise returns error
   */
  requestToken(email) {
    return this.$http.post('/api/auth/sendtoken', { user: email }).then(result => {
      return result;
    }, (error) => {
      return error;
    });
  }

  /**
   * @memberOf LoginService
   * @param {string} uid User id of the user logging in
   * @param {string} token passwordless token for the user
   * @description Calls api to log in user with uid and token.
   * @returns {object} Error with message if failed login, User payload if login is successful
   */
  login(uid, token) {
    this.authService.cleanToken();
    return this.$http.post('/api/auth/login', { uid: uid, token: token }).then(result => {
      if (result.data.success) {
        this.authService.setToken(result.data.jwt);
        return result.data;
      } else {
        this.authService.cleanToken();
        return {
          message: 'Error: Token is Invalid',
          reason: result.data,
          success: false
        };
      }
    });
  }

  /**
   * @memberOf LoginService
   * @description Logs user out of session. Calls AuthService's cleanToken to clean token, and stops watching screen
   * for idleness.
   */
  logout() {
    this.idle.unwatch();
    this.authService.cleanToken();
  }

  /**
   * @memberOf LoginService
   * @description Checks to see if user is logged in by calling Auth Service's isLoggedIn method.
   * @returns {Boolean} True if user is logged in, false if not.
   */
  isLoggedIn() {
    return this.authService.isLoggedIn();
  }

  /**
   * @memberOf LoginService
   * @description Gets information about current logged in user by calling AuthService's currentUser method.
   * @returns {object} Payload of current user
   */
  currentUser() {
    return this.authService.currentUser();
  }
}

export default angular.module('services.login', [])
  .service('LoginService', LoginService)
  .name;

LoginService.$inject = ['$http', '$window', '$q', '$state', 'AuthService', 'Idle'];



// WEBPACK FOOTER //
// ./src/client/app/services/login.service.js